/* eslint-disable max-len */
export const FAQQuestions = [
	// no category
	{
		slug: 'apakah-klik-dokter-gratis',
		slug_category: null,
		title: 'Apakah KlikDokter gratis?',
		answer:
			'<p>Kamu bisa dengan bebas mengakses semua informasi kesehatan yang terdapat di KlikDokter kapan saja dan di mana saja. KlikDokter menyediakan layanan telekonsultasi dengan dokter umum maupun spesialis dengan tarif yang terjangkau.</p>',
	},
	{
		slug: 'kenapa-pengguna-diminta-memberikan-akses-lokasi-media-galeri-kamera-dan-file',
		slug_category: null,
		title: 'Kenapa pengguna diminta memberikan akses lokasi, media, galeri, kamera, dan file?',
		answer:
			'<p>Beberapa layanan di KlikDokter memungkinkan kamu untuk mengirimkan lampiran untuk kebutuhan konsultasi kesehatan atau penebusan resep.</p>',
	},
	{
		slug: 'apakah-layanan-pengiriman-obat-tersedia-di-kota-saya',
		slug_category: null,
		title: 'Apakah layanan pengiriman obat tersedia di kota saya?',
		answer:
			'<p>Layanan pengiriman obat KlikDokter tersedia di Jabodetabek dan kota-kota besar di Indonesia.</p>',
	},
	{
		slug: 'berapa-lama-obat-saya-dikirim',
		slug_category: null,
		title: 'Berapa lama obat saya dikirim?',
		answer:
			'<p>Dengan instant delivery memungkinkan obat diterima 60 menit setelah proses pembayaran dilakukan.</p>',
	},
	{
		slug: 'saya-ingin-berkonsultasi-dengan-dokter-berapa-biayanya',
		slug_category: null,
		title: 'Saya ingin berkonsultasi dengan dokter, berapa biayanya?',
		answer:
			'<p>Kamu bisa berkonsultasi dengan dokter kapan saja dan di mana saja. KlikDokter menyediakan layanan telekonsultasi dengan dokter umum maupun spesialis dengan tarif yang terjangkau.</p>',
	},
	{
		slug: 'konsultasi-saya-ditolak-dokter-apa-yang-harus-saya-lakukan',
		slug_category: null,
		title: 'Konsultasi saya ditolak dokter, apa yang harus saya lakukan?',
		answer:
			'<p>Terkadang dalam kondisi darurat dokter harus menangani pasien lain sehingga tidak bisa melayani telekonsultasi dan terpaksa harus membatalkan telekonsultasi baik yang sudah dijadwalkan atau belum. Kamu tidak perlu khawatir, kami akan mengembalikan dana yang sudah kamu bayarkan dalam bentuk voucher telekonsultasi senilai dana yang sudah kamu bayarkan sebelumnya sehingga kamu bisa melakukan telekonsultasi dengan dokter lain.</p>',
	},
	{
		slug: 'berapa-lama-saya-harus-menunggu-dokter-untuk-menerima-chat-saya-untuk-mulai-berkonsultasi',
		slug_category: null,
		title:
			'Berapa lama saya harus menunggu Dokter untuk menerima chat saya untuk mulai berkonsultasi?',
		answer:
			'<p>Batas waktu untuk dokter menerima permintaan chat dari Pasien adalah 2 menit, apabila sampai batas waktu tersebut dokter belum menerima permintaan chat kamu, maka kami akan mengembalikan dana yang sudah kamu bayarkan dalam bentuk voucher telekonsultasi senilai dana yang sudah kamu bayarkan sebelumnya, sehingga kamu bisa melakukan telekonsultasi dengan dokter lain.</p>',
	},
	{
		slug: 'apakah-klik-dokter-menjamin-kompetensi-dari-mitra-dokternya',
		slug_category: null,
		title: 'Apakah KlikDokter menjamin kompetensi dari mitra dokternya?',
		answer:
			'<p>Tentu. KlikDokter melakukan peninjauan latar belakang medis dari semua mitra dokter kami untuk memastikan bahwa dokter yang menjadi mitra kami adalah dokter yang memiliki kompetensi. Selain itu, pada menu konsultasi kamu dapat melihat portofolio dari dokter yang dipilih.</p>',
	},
	{
		slug: 'apakah-ada-batas-waktu-untuk-saya-berkonsultasi-dengan-dokter',
		slug_category: null,
		title: 'Apakah ada batas waktu untuk saya berkonsultasi dengan dokter?',
		answer:
			'<p>Benar. Kamu memiliki waktu selama 30 menit untuk melakukan konsultasi dengan dokter.</p>',
	},
	{
		slug: 'apakah-konsultasi-dengan-dokter-dapat-ditanggung-oleh-asuransi-atau-bpjs',
		slug_category: null,
		title: 'Apakah konsultasi dengan dokter dapat ditanggung oleh asuransi atau BPJS?',
		answer:
			'<p>Mohon maaf untuk saat ini layanan konsultasi dengan dokter belum dapat ditanggung oleh asuransi maupun BPJS.</p>',
	},
	{
		slug: 'obat-yang-saya-terima-tidak-sesuai-dengan-yang-ada-pada-resep-apa-yang-dapat-saya-lakukan',
		slug_category: null,
		title:
			'Obat yang saya terima tidak sesuai dengan yang ada pada resep. Apa yang dapat saya lakukan?',
		answer:
			'<p>Mohon maaf atas ketidaknyamanan yang dialami. Kamu dapat menghubungi Customer Care apabila mengalami mengalami hal tersebut dengan cara Whatsapp ke nomor 0811-800-629 atau mengirimkan Email ke <a href="mailto:cs@klikdokter.com">cs@klikdokter.com</a>. Jam operasional Customer Care KlikDokter setiap hari selama 24 jam.</p>',
	},
	{
		slug: 'saya-belum-mendapatkan-diagnosa-jawaban-namun-waktu-konsultasi-sudah-habis-apa-yang-harus-saya-lakukan',
		slug_category: null,
		title:
			'Saya belum mendapatkan diagnosis/jawaban namun waktu konsultasi sudah habis. Apa yang harus saya lakukan?',
		answer:
			'<p>KlikDokter memberikan waktu konsultasi selama 30 menit. Apabila telah melewati waktu yang diberikan, kami sarankan kamu untuk melakukan konsultasi kembali.</p>',
	},
	// profil-saya
	{
		slug: 'pendaftaran-akun',
		slug_category: 'profil-saya',
		title: 'Pendaftaran Akun',
		answer:
			'<p>Klik tombol "Masuk" dan lakukan langkah berikut :</p><ol><li><p>Masukkan nomor ponsel.</p></li><li><p>KlikDokter akan mengirimkan kode verifikasi via SMS ke nomor tersebut.</p></li><li><p>Isi kode verifikasi.</p></li><li><p>Buat PIN yang akan digunakan untuk masuk ke akun kamu.</p></li><li><p>Konfirmasi PIN kamu.</p></li><li><p>Masukkan nama kamu.</p></li><li><p>Pilih minimal 3 topik kesehatan kamu.</p></li></ol>',
	},
	{
		slug: 'masuk-akun',
		slug_category: 'profil-saya',
		title: 'Masuk Akun',
		answer:
			'<p>Klik tombol "Masuk" dan lakukan langkah berikut :</p><ol><li>Masukan nomor ponsel.</li><li>Masukkan PIN kamu.</li></ol>',
	},
	{
		slug: 'lupa-pin',
		slug_category: 'profil-saya',
		title: 'Saya Lupa PIN',
		answer:
			'<p>Lupa PIN? Kamu bisa atur ulang PIN dengan cara klik tautan <b>Atur Ulang</b> yang tersedia pada bagian Masukkan PIN kamu.</p>',
	},
	{
		slug: 'cari-profil-saya',
		slug_category: 'profil-saya',
		title: 'Bagaimana cara menemukan Profil Saya?',
		answer:
			'<ol><li>Klik foto profil atau ikon yang berada di bagian pojok kanan atas</li><li>Pilih kotak sebelah kiri yang bertuliskan <strong>Hi,{nama kamu}</strong></li></ol>',
	},
	{
		slug: 'ubah-profil-saya',
		slug_category: 'profil-saya',
		title: 'Bagaimana cara mengubah Profil Saya?',
		answer:
			'<p>Kamu bisa melakukan perubahan sebagai berikut di menu Profil Saya:</p><ol><li>Nama.</li><li>Tanggal lahir.</li><li>Tinggi badan (cm).</li><li>Berat badan (kg).</li><li>Jenis kelamin.</li><li>Email.</li><li>Ganti PIN.</li><li>Ubah nomor ponsel.</li></ol>',
	},
	{
		slug: 'tambah-keluarga',
		slug_category: 'profil-saya',
		title: 'Tambah Keluarga',
		answer:
			'<p>Di KlikDokter, Kamu bisa menambahkan profil keluarga dengan cara berikut:</p><ol><li>Klik ikon tambah.</li><li><b>Pilih Hubungan</b> keluarga dan nomor ponsel yang akan didaftarkan.</li><li>Klik <b>Lanjut</b>, sistem KlikDokter akan melakukan pengecekan.</li><li>Jika nomor ponsel sudah terdaftar di KlikDokter, kamu bisa klik <b>Hubungkan</b> untuk menambahkan anggota keluarga.</li><li>Jika nomor ponsel belum terdaftar, kamu bisa lanjutkan mengisi nama dan klik <b>Hubungkan</b> untuk menambahkan anggota keluarga.</li></ol>',
	},
	{
		slug: 'tambah-riwayat-kesehatan',
		slug_category: 'profil-saya',
		title: 'Bagaimana cara menambahkan riwayat kesehatan?',
		answer:
			'<p>Kamu bisa memasukkan dokumen yang berhubungan dengan riwayat kesehatan kamu. Klik tombol <strong>Upload Dokumen</strong> untuk memasukkan dokumen kesehatan yang kamu butuhkan.</p>',
	},
	{
		slug: 'daftar-alamat',
		slug_category: 'profil-saya',
		title: 'Daftar Alamat',
		answer:
			'<p>Di dalam menu <b>Daftar Alamat</b> kamu bisa menambahkan beberapa alamat yang bisa digunakan sebagai lokasi pengantaran produk.</p>',
	},
	{
		slug: 'cara-tambah-alamat',
		slug_category: 'profil-saya',
		title: 'Cara menambahkan alamat',
		answer:
			'<ol><li>Masuk ke menu <strong>Daftar Alamat</strong>.</li><li>Klik <strong>Tambah Alamat</strong>.</li><li>Tentukan titik pin point lokasi kamu atau lakukan cari alamat di kolom pencarian.</li><li>Klik <strong>Pilih Pinpoint</strong>.</li><li>Lengkapi detail alamat dengan memilih <strong>Label Alamat</strong> , masukkan alamat lengkap, catatan, dan nomor ponsel yang bisa dihubungi.</li><li>Klik <strong>Konfirmasi</strong> lalu <strong>Simpan</strong> untuk menyimpan alamat.</li></ol>',
	},
	{
		slug: 'dokter-favorit',
		slug_category: 'profil-saya',
		title: 'Dokter Favorit',
		answer:
			'<p>Kamu bisa menambahkan <strong>Dokter Favorit</strong> dengan cara sebagai berikut:</p><ol><li>Pilih menu <strong>Dokter Favorit</strong>.</li><li>Klik <strong>Cari Dokter</strong>.</li><li>Pilih salah satu dokter dengan cara klik tombol <strong>Mulai Konsultasi</strong> di bagian dokter yang kamu kehendaki.</li><li>Klik ikon 🤍 untuk menambahkan ke daftar <strong>Dokter Favorit</strong>.</li></ol>',
	},
	{
		slug: 'topik-saya',
		slug_category: 'profil-saya',
		title: 'Topik Saya',
		answer:
			'<p>Pada menu <strong>Topik Saya </strong>kamu bisa menambahkan 3 topik pilihan yang diinginkan.</p>',
	},
	{
		slug: 'riwayat-kesehatan',
		slug_category: 'profil-saya',
		title: 'Riwayat Kesehatan',
		answer:
			'<p>Pada menu <strong>Riwayat Kesehatan</strong> kamu bisa menemukan riwayat konsultasi dengan dokter, penebusan resep, maupun janji medis yang kamu lakukan sebelumnya.</p>',
	},
	{
		slug: 'menunggu-pembayaran',
		slug_category: 'profil-saya',
		title: 'Menunggu Pembayaran',
		answer:
			'<p>Pada menu <strong>Menunggu Pembayaran</strong> terdapat daftar transaksi yang masih menunggu pembayaran kamu.</p>',
	},
	{
		slug: 'daftar-transaksi',
		slug_category: 'profil-saya',
		title: 'Daftar Transaksi',
		answer:
			'<p>Menu <strong>Daftar Transaksi </strong>memungkinkan kamu melihat kembali seluruh transaksi yang kamu lakukan di KlikDokter.</p>',
	},
	{
		slug: 'wallet',
		slug_category: 'profil-saya',
		title: 'Wallet',
		answer:
			'<p>Menu <b>Wallet</b> memungkinkan untuk menghubungkan akun KlikDokter mu dengan GoPay dan ShopeePay untuk memudahkan pembayaran serta menikmati promo di KlikDokter.</p>',
	},
	{
		slug: 'undang-teman',
		slug_category: 'profil-saya',
		title: 'Undang Teman',
		answer:
			'<p><b>Undang Teman</b> kamu menggunakan serta bertransaksi di KlikDokter untuk mendapatkan poin.</p>',
	},
	{
		slug: 'sehat-squad',
		slug_category: 'profil-saya',
		title: 'Sehat Squad',
		answer:
			'<p>Dapatkan beragam keuntungan dari <b>Sehat Squad</b>. Kamu bisa menikmati keuntungan seperti voucher ulang tahun dan voucher potongan ongkos kirim. Semakin tinggi level membershipmu, semakin banyak keuntungan yang kamu dapatkan!.</p>',
	},
	{
		slug: 'klikpoin',
		slug_category: 'profil-saya',
		title: 'KlikPoin',
		answer:
			'<p>Kumpulkan <strong>KlikPoin</strong> dari transaksi yang kamu lakukan dan dapat kamu gunakan untuk pembayaran transaksi di KlikDokter.</p>',
	},
	// tanya-dokter
	{
		slug: 'layanan-tanya-dokter',
		slug_category: 'tanya-dokter',
		title: 'Layanan Tanya Dokter',
		answer:
			'<p>Layanan <b>Tanya Dokter</b> memungkinkan kamu untuk dapat berkonsultasi dengan dokter atau tenaga kesehatan lainnya yang telah terdaftar di aplikasi KlikDokter secara online, kapanpun dan dimanapun melalu live chat, video, maupun tatap muka. Layanan ini tersedia di Android, iOS, dan Website.</p>',
	},
	{
		slug: 'cara-konsultasi-chat',
		slug_category: 'tanya-dokter',
		title: 'Cara melakukan Tanya Dokter melalui Konsultasi Chat',
		answer:
			'<p>Cara untuk dapat berkonsultasi chat dengan dokter adalah sebagai berikut:</p><ol><li>Download aplikasi KlikDokter pada smartphone kamu atau akses halaman berikut <a href="https://klikdokter.com/tanya-dokter">https://klikdokter.com/tanya-dokter</a>, menggunakan browser kamu.</li><li>Pastikan kamu telah memiliki akun KlikDokter, apabila belum memiliki akun, silakan untuk mendaftar terlebih dahulu.</li><li>Pada aplikasi KlikDokter, pilih menu Tanya Dokter. Sistem akan menampilkan list data dokter dan tenaga kesehatan yang tersedia</li><li>Pilih Dokter atau tenaga kesehatan sesuai kebutuhan kamu dan pastikan memilih konsultasi chat.</li><li>Pilih jadwal sesuai slot yang tersedia.</li><li>Kamu akan diarahkan untuk melakukan pembayaran terlebih dahulu dengan metode pembayaran yang tersedia. </li><li>Kamu juga dapat memasukkan kode voucher jika memiliki. </li><li>Setelah menyelesaikan pembayaran, kamu akan diarahkan untuk menunggu sampai dokter menerima permintaan chat kamu, maksimum waktu tunggu adalah 2 menit</li><li>Setelah dokter menerima permintaan, kamu akan diarahkan ke halaman chat room untuk dapat berkonsultasi dengan dokter.</li><li>Setelah sesi konsultasi dengan dokter selesai, kamu diharapkan memberikan rating terhadap pelayanan yang telah diberikan dokter.</li><li>Kamu akan menerima email ringkasan konsultasi chat setelah sesi chat berakhir. Klik "Download" untuk mendownload kuitansi digital.</li></ol>',
	},
	{
		slug: 'cara-konsultasi-video',
		slug_category: 'tanya-dokter',
		title: 'Cara melakukan Tanya Dokter melalui Konsultasi Video',
		answer:
			'<p>Cara untuk dapat melakukan video call dengan dokter adalah sebagai berikut::</p><ol><li>Download aplikasi KlikDokter pada smartphone kamu, layanan video call hanya dapat dilakukan melalui smartphone aplikasi KlikDokter.</li><li>Pastikan kamu telah memiliki akun KlikDokter, apabila belum memiliki akun, silakan untuk mendaftar terlebih dahulu.</li><li>Pada aplikasi KlikDokter, pilih menu Tanya Dokter. Sistem akan menampilkan list data dokter dan tenaga kesehatan yang tersedia.</li><li>Pilih Dokter atau tenaga kesehatan sesuai kebutuhan kamu dan pastikan memilih konsultasi video chat.</li><li>Selanjutnya kamu akan diarahkan untuk melakukan pembayaran terlebih dahulu dengan metode pembayaran yang tersedia.</li><li>Kamu juga dapat memasukkan kode voucher jika memiliki. </li><li>Setelah menyelesaikan pembayaran, kamu akan diarahkan untuk menunggu sampai dokter menerima permintaan chat kamu, maksimum waktu tunggu adalah 3 menit.</li><li>Setelah dokter menerima permintaan, kamu akan diarahkan ke halaman chat room untuk dapat berkonsultasi dengan dokter dan melakukan video call.</li><li>Setelah sesi konsultasi dengan dokter selesai, kamu diharapkan memberikan rating terhadap pelayanan yang telah diberikan dokter.</li><li>Kamu dapat melihat kuitansi digital pada halaman transaksi.</li></ol>',
	},
	{
		slug: 'cara-konsultasi-tatap-muka',
		slug_category: 'tanya-dokter',
		title: 'Cara melakukan Tanya Dokter melalui Konsultasi Tatap Muka',
		answer:
			'<p>Cara untuk dapat berkonsultasi chat dengan dokter adalah sebagai berikut:</p><ol><li>Download aplikasi KlikDokter pada smartphone kamu atau akses halaman berikut <a href="https://klikdokter.com/tanya-dokter">https://klikdokter.com/tanya-dokter</a>, menggunakan browser kamu.</li><li>Pastikan kamu telah memiliki akun KlikDokter, apabila belum memiliki akun, silakan untuk mendaftar terlebih dahulu.</li><li>Pada aplikasi KlikDokter, pilih menu Tanya Dokter. Sistem akan menampilkan list data dokter dan tenaga kesehatan yang tersedia.</li><li>Pilih Dokter atau tenaga kesehatan sesuai kebutuhan kamu dan pastikan memilih konsultasi tatap muka.</li><li>Pilih jadwal sesuai slot yang tersedia serta Rumah Sakit/Kliniknya.</li><li>Klik button Buat Janji</li></ol>',
	},
	// tebus-resep
	{
		slug: 'layanan-tebus-resep',
		slug_category: 'tebus-resep',
		title: 'Layanan Tebus Resep',
		answer:
			'<p>Fitur ini memungkinkan kamu melakukan tebus obat dari resep digital yang kamu dapatkan setelah kamu berkonsultasi dengan dokter KlikDokter. Fitur ini tersedia di Android, iOS dan Website.</p>',
	},
	{
		slug: 'cara-tebus-resep',
		slug_category: 'tebus-resep',
		title: 'Cara Melakukan Penebusan Resep Dokter di KlikDokter',
		answer:
			'<p>Cara untuk melakukan tebus resep setelah melakukan konsultasi dengan dokter adalah:</p><ol><li>Klik resep yang diberikan oleh dokter.</li><li>Klik button Tebus Resep pada bagian bawah.</li><li>Tentukan alamat pengiriman dan klik button Konfirmasi Alamat.</li><li>Pilih metode pembayaran yang diinginkan dan klik button Bayar Tagihan.</li><li>Setelah pembayaran dilakukan, pesanan akan dikirimkan ke lokasi pengiriman.</li></ol>',
	},
	// health-tools
	{
		slug: 'apa-itu-healthtools',
		slug_category: 'health-tools',
		title: 'Apa itu Health Tools',
		answer:
			'<p>KlikDokter memiliki berbagai Health Tools yang dapat kamu gunakan untuk menunjang gaya hidup sehat kamu.</p>',
	},
	{
		slug: 'apa-saja-healthtools-yang-tersedia-di-klikdokter',
		slug_category: 'health-tools',
		title: 'Apa saja Health Tools yang tersedia di KlikDokter',
		answer:
			'<ol><li>Kalendar Kehamilan: Fitur yang membantu kamu mengetahui kapan masa subur Mama dan kapan Si Kecil akan lahir.</li><li>Kalkulator Body Mass Index (BMI): Fitur yang membantu mengetahui berat badan ideal mu.</li><li>Cegah Diabetes: Fitur ini memungkinkan untuk kamu melakukan pengecekan risiko diabetes.</li><li>Jaga Jantung: Fitur ini memungkinkan untuk kamu melakukan pengecekan risiko jantung.</li><li>Cegah Kanker: Fitur ini memungkinkan untuk kamu melakukan deteksi dini terhadap kanker.</li></ol>',
	},
	// metode-pembayaran
	{
		slug: 'pembayaran-gopay-melalui-apps',
		slug_category: 'metode-pembayaran',
		title: 'Pembayaran GoPay melalui Aplikasi',
		answer:
			'<ol><li>Pada halaman Metode Pembayaran, muncul list metode pembayaran.</li><li>Pilih pembayaran GoPay.</li><li>Cek detail transaksi di aplikasi GO-JEK kamu. Apabila sudah sesuai, klik Bayar lalu masukkan 6-digit PIN GoPay kamu.</li><li>Pembayaran akan terverifikasi secara otomatis jika pembayaran berhasil, kamu juga akan menerima notifikasi Payment Successful pada aplikasi GO-JEK kamu.</li><li>Untuk memastikan transaksi berhasil, pastikan saldo GoPay mencukupi nilai total transaksi.</li></ol>',
	},
	// {
	// slug: 'pembayaran-menggunakan-ovo',
	// slug_category: 'metode-pembayaran',
	// title: 'Pembayaran menggunakan OVO',
	// answer:
	// '<ol><li>Pada halaman Metode Pembayaran, muncul list metode pembayaran.</li><li>Pilih pembayaran OVO, lalu masukkan nomor handphone yang terdaftar pada aplikasi OVO, kemudian klik Lanjut.</li><li>Waktu maksimal pembayaran dengan OVO adalah 60 detik.</li><li>Periksa detail pembayaran kamu pada aplikasi OVO, lalu tekan Bayar.</li><li>Masukkan PIN kamu.</li><li>Transaksi kamu telah selesai.</li></ol>',
	// },
	{
		slug: 'pembayaran-menggunakan-shopeepay',
		slug_category: 'metode-pembayaran',
		title: 'Pembayaran menggunakan ShopeePay',
		answer:
			'<ol><li>Pada halaman Metode Pembayaran, muncul list metode pembayaran.</li><li>Pilih pembayaran ShopeePay, lalu klik Lanjut.</li><li>Waktu maksimal pembayaran dengan ShopeePay adalah 5 menit.</li><li>Periksa detail pembayaran kamu pada aplikasi Shopee, lalu tekan Bayar.</li><li>Masukkan PIN kamu.</li><li>Transaksi kamu telah selesai.</li></ol>',
	},
	{
		slug: 'cara-melakukan-pembayaran-menggunakan-qris',
		slug_category: 'metode-pembayaran',
		title: 'Cara melakukan pembayaran menggunakan QRIS',
		answer:
			'<ol><li>Klik tombol bayar dengan QRIS setelah kamu melakukan Place Order.</li><li>Kamu akan menerima QR Code.</li><li>Pilih dan buka aplikasi yang memiliki metode pembayaran QRIS untuk membayar pesanan kamu.</li><li>Periksa kembali detail pembayaran kamu di aplikasi, lalu tekan Lanjutkan dan pilih Bayar sekarang.</li><li>Transaksi selesai.</li></ol>',
	},
	{
		slug: 'cara-pembayaran-menggunakan-virtual-account',
		slug_category: 'metode-pembayaran',
		title: 'Cara pembayaran menggunakan Virtual Account',
		answer:
			'<p>Virtual Account adalah angka unik yang disediakan oleh bank yang bekerjasama dengan KlikDokter untuk kamu gunakan sebagai nomor rekening/kode pembayaran pada pembayaran transaksi kamu di KlikDokter dengan minimum pembayaran Rp10.000,00. Pada metode pembayaran ini, nomor rekening/kode pembayaran yang kamu dapatkan akan berbeda tiap kali kamu melakukan transaksi di KlikDokter.</p><p>&nbsp;</p><ol><li>Untuk menggunakan metode pembayaran ini, pada halaman Metode Pembayaran pilih Virtual Account.</li><li>Pilih bank yang kamu gunakan lalu klik Lanjut.</li><li>Kode virtual account, detail pesanan, dan nominal pembayaran akan muncul pada halaman petunjuk pembayaran. </li><li>Waktu maksimal pembayaran dengan Virtual Account adalah 3 jam untuk transaksi Tebus Resep, 15 menit untuk transaksi Telekonsultasi Chat.</li></ol>',
	},
	{
		slug: 'petunjuk-pembayaran-virtual-account-di-atm-bank-bca',
		slug_category: 'metode-pembayaran',
		title: 'Petunjuk Pembayaran Virtual Account di ATM Bank BCA',
		answer:
			'<ol><li>Masukkan Kartu ATM BCA & PIN.</li><li>Pilih menu Transaksi Lainnya > Transfer > ke Rekening BCA Virtual Account.</li><li>Masukkan Nomor Virtual Account BCA yang Terdapat pada layar.</li><li>Di halaman konfirmasi, pastikan detail pembayaran sudah sesuai seperti No VA, Nama, Perusahaan/Produk dan Total Tagihan.</li><li>Masukkan Jumlah Transfer sesuai dengan Total Tagihan.</li><li>Ikuti instruksi untuk menyelesaikan transaksi.</li><li>Simpan struk transaksi sebagai bukti pembayaran.</li></ol>',
	},
	{
		slug: 'petunjuk-pembayaran-virtual-account-di-m-bca',
		slug_category: 'metode-pembayaran',
		title: 'Petunjuk Pembayaran Virtual Account di m-BCA',
		answer:
			'<ol><li>Lakukan log in pada aplikasi BCA Mobile.</li><li>Pilih menu m-BCA, kemudian masukkan kode akses m-BCA.</li><li>Pilih m-Transfer > BCA Virtual Account.</li><li>Masukkan Nomor Virtual Account BCA yang Terdapat pada layar.</li><li>Masukkan pin m-BCA.</li><li>Pembayaran selesai. Simpan notifikasi yang muncul sebagai bukti pembayaran.</li></ol>',
	},
	{
		slug: 'petunjuk-pembayaran-virtual-account-di-atm-bank-bri',
		slug_category: 'metode-pembayaran',
		title: 'Petunjuk Pembayaran Virtual Account di ATM Bank BRI',
		answer:
			'<ol><li>Di menu utama, pilih Transaksi Lainnya.</li><li>Pilih Pembayaran.</li><li>Pilih Lainnya.</li><li>Pilih BRIVA.</li><li>Masukkan nomor BRI Virtual Account kamu dan tekan Benar.</li><li>Jumlah yang harus dibayar, nomor akun dan nama merchant akan muncul di halaman konfirmasi pembayaran, jika informasinya benar maka klik lanjutkan.</li><li>Pembayaran sudah selesai. Simpan pemberitahuan sebagai tanda terima pembayaran kamu.</li></ol>',
	},
	{
		slug: 'petunjuk-pembayaran-virtual-account-di-briva',
		slug_category: 'metode-pembayaran',
		title: 'Petunjuk Pembayaran Virtual Account di BRIVA',
		answer:
			'<ol><li>Login ke Mobile Banking.</li><li>Pilih Pembayaran.</li><li>Pilih BRIVA.</li><li>Masukkan nomor BRI Virtual Account dan jumlah pembayaran.</li><li>Masukan nomor PIN kamu.</li></ol>',
	},
	{
		slug: 'petunjuk-pembayaran-virtual-account-di-atm-bank-bni',
		slug_category: 'metode-pembayaran',
		title: 'Petunjuk Pembayaran Virtual Account di ATM Bank BNI',
		answer:
			'<ol><li>Di menu utama, pilih Transaksi Lainnya.</li><li>Pilih Transfer.</li><li>Pilih Nomor Rekening.</li><li>Pilih ke Rekening BNI.</li><li>Masukkan Kode Pembayaran kamu, lalu tekan Ya.</li><li>Masukkan jumlah pembayaran, jika jumlah pembayaran tidak sama dengan invoice maka transaksi akan ditolak.</li><li>Rincian pembayaran kamu akan muncul di halaman konfirmasi pembayaran. Jika informasinya benar tekan Ya.</li><li>Transaksi kamu selesai.</li></ol>',
	},
	{
		slug: 'petunjuk-pembayaran-virtual-account-di-internet-banking-bni',
		slug_category: 'metode-pembayaran',
		title: 'Petunjuk Pembayaran Virtual Account di Internet Banking BNI',
		answer:
			'<ol><li>Masuk ke <a href="https://ibank.bni.co.id" target="blank">https://ibank.bni.co.id</a> lalu pilih Login.</li><li>Lanjut proses Login menggunakan User ID dan Password.</li><li>Pilih Transfer, lalu pilih Tambah Add Favorite Account dan pilih Antar Rekening BNI.</li><li>Masukkan Nama, Nomor Rekening, dan Email, lalu pilih Lanjutkan.</li><li>Kembali ke menu utama, lalu pilih Transfer, kemudian Transfer Antar Rekening BNI.</li><li>Pilih Rekening yang telah dibuat pada langkah sebelumnya sebagai Rekening Tujuan, lalu lengkapi info sebelum memilih Lanjutkan.</li><li>Periksa apabila detail pembayaran telah benar, jika benar, maka masukkan Authentification Code dan pilih Lanjutkan. Transaksi kamu selesai.</li><li>Transaksi kamu selesai.</li></ol>',
	},
	{
		slug: 'petunjuk-pembayaran-virtual-account-di-bni-mobile',
		slug_category: 'metode-pembayaran',
		title: 'Petunjuk Pembayaran Virtual Account di BNI mobile',
		answer:
			'<ol><li>Masuk ke aplikasi BNI Mobile kamu.</li><li>Pilih menu Transfer.</li><li>Pilih menu Virtual Account Billing.</li><li>Pilih Nomor Rekening yang akan digunakan.</li><li>Masukkan 16 digit nomor Virtual Account.</li><li>Rincian pembayaran kamu akan muncul di halaman konfirmasi pembayaran.</li><li>Jika informasi telah sesuai, masukkan password untuk memproses pembayaran.</li><li>Transaksi kamu akan diproses.</li></ol>',
	},
	{
		slug: 'petunjuk-pembayaran-virtual-account-di-atm-bank-mandiri',
		slug_category: 'metode-pembayaran',
		title: 'Petunjuk Pembayaran Virtual Account di ATM Bank Mandiri',
		answer:
			'<ol><li>Pada menu utama, pilih Bayar/Beli.</li><li>Pilih Lainnya.</li><li>Pilih Multi Pembayaran.</li><li>Masukkan 70012 (kode perusahaan Midtrans) dan tekan Benar.</li><li>Masukkan Kode Pembayaran kamu dan tekan Benar.</li><li>Rincian pembayaran kamu akan muncul di halaman konfirmasi pembayaran. Jika informasinya benar tekan Ya.</li></ol>',
	},
	{
		slug: 'petunjuk-pembayaran-virtual-account-di-internet-banking-mandiri',
		slug_category: 'metode-pembayaran',
		title: 'Petunjuk Pembayaran Virtual Account di Internet Banking Mandiri',
		answer:
			'<ol><li>Masuk ke Mandiri Internet Banking (<a href="https://ib.bankmandiri.co.id" target="_blank">https://ib.bankmandiri.co.id</a>).</li><li>Dari menu utama pilih Pembayaran, lalu pilih Multi Pembayaran.</li><li>Silakan pilih akun rekening kamu, lalu pada Nama Penagihan pilih Midtrans.</li><li>Masukkan Kode Pembayaran dan kamu akan menerima detail pembayaran kamu.</li><li>Konfirmasikan pembayaran kamu menggunakan Token Mandiri kamu.</li></ol>',
	},
	{
		slug: 'petunjuk-pembayaran-virtual-account-di-atm-bank-permata',
		slug_category: 'metode-pembayaran',
		title: 'Petunjuk Pembayaran Virtual Account di ATM Bank Permata',
		answer:
			'<ol><li>Di menu utama, pilih Transaksi Lainnya.</li><li>Pilih Pembayaran.</li><li>Pilih Pembayaran Lainnya.</li><li>Pilih Virtual Account.</li><li>Masukkan 16 digit nomor Virtual Account. Lalu tekan Benar.</li><li>Jumlah yang harus dibayar, Nomor Rekening, serta Nama Merchant akan muncul di halaman konfirmasi pembayaran. Jika informasinya telah sesuai, tekan Benar.</li><li>Pilih rekening pembayaran kamu lalu tekan Benar.</li></ol>',
	},
	{
		slug: 'petunjuk-pembayaran-virtual-account-di-atm-bank-maybank',
		slug_category: 'metode-pembayaran',
		title: 'Petunjuk Pembayaran Virtual Account di ATM Maybank',
		answer:
			'<ol><li>Masukkan kartu ATM kemudian masukkan nomor PIN.</li><li>Pilih Transfer, lalu Virtual Account.</li><li>Masukkan nomor Virtual Account (nomor virtual account KlikDokter), lalu tekan Benar.</li><li>Masukkan jumlah nominal sesuai dengan tagihan yang akan dibayarkan.</li><li>Pilih Ya untuk memproses transaksi.</li></ol>',
	},
	{
		slug: 'petunjuk-pembayaran-virtual-account-di-atm-bank-prima',
		slug_category: 'metode-pembayaran',
		title: 'Petunjuk Pembayaran Virtual Account di ATM Prima',
		answer:
			'<ol><li>Masukkan kartu ATM, kemudian masukkan nomor PIN.</li><li>Pilih Transfer, pilih Rekening Bank Lain.</li><li>Masukkan nomor 016 (Kode Maybank) lalu tekan Benar.</li><li>Masukkan jumlah nominal sesuai dengan tagihan yang akan dibayarkan.</li><li>Masukkan Nomor Virtual Account (Contoh:(nomor kode KlikDokter)xxxxxxxxx) lalu tekan Benar.</li><li>Pilih Benar jika jumlah pembayaran sudah sesuai.</li></ol>',
	},
	{
		slug: 'petunjuk-pembayaran-virtual-account-di-atm-bank-bersama',
		slug_category: 'metode-pembayaran',
		title: 'Petunjuk Pembayaran Virtual Account di ATM Bersama',
		answer:
			'<ol><li>Pilih Transfer, pilih Antar Bank Online.</li><li>Masukkan nomor 016 (Kode Maybank) + 16 digit nomor Virtual Account (Contoh:(nomor kode KlikDokter)xxxxxxxxx).</li><li>Masukkan jumlah nominal sesuai dengan tagihan yang akan dibayarkan.</li><li>Pilih Benar jika jumlah pembayaran sudah sesuai.</li></ol>',
	},
	{
		slug: 'petunjuk-pembayaran-virtual-account-di-atm-bank-cimb-niaga',
		slug_category: 'metode-pembayaran',
		title: 'Petunjuk Pembayaran Virtual Account di ATM CIMB Niaga',
		answer:
			'<ol><li>Masukkan Kartu ATM dan PIN.</li><li>Pilih menu Pembayaran -> Lanjut -> Virtual Account.</li><li>Masukkan nomor Virtual Account (Nomor Virtual KlikDokter).</li><li>Pilih rekening debit.</li><li>Periksa kembali nama kamu dan jumlah pembayaran apakah sudah sesuai. Jika sudah, pilih OK untuk melakukan pembayaran.</li><li>Transaksi selesai.</li></ol>',
	},
	{
		slug: 'petunjuk-pembayaran-virtual-account-di-atm-mbank-cimb-niaga',
		slug_category: 'metode-pembayaran',
		title: 'Petunjuk Pembayaran Virtual Account di M-Banking CIMB Niaga',
		answer:
			'<ol><li>Login ke CIMB clicks.</li><li>Pilih menu Bayar Tagihan/Pay Bills.</li><li>Pilih Rekening Sumber / Source Account dan Jenis Pembayaran / Payment Type -> Virtual Account.</li><li>Masukkan nomor virtual account kamu.</li><li>Pastikan Merchant adalah KlikDokter, Nama kamu dan jumlah pembayaran sudah sesuai. Jika sudah, masukkan PIN dan tekan tombol Submit.</li><li>Transaksi selesai.</li></ol>',
	},
	{
		slug: 'cara-mengajukan-pengembalian-dana',
		slug_category: 'metode-pembayaran',
		title: 'Cara mengajukan pengembalian dana',
		answer:
			'<p>Apabila kamu memiliki keluhan mengenai proses transaksi ataupun pengiriman obat/produk, maka kamu dapat mengklik button Bantuan pada halaman Detail Transaksi. Sistem akan mengarahkan kamu pada halaman Laporkan Masalah, keluhan yang kamu ajukan tersebut secara otomatis akan terkirim pada email Customer Service KlikDokter.</p><p>Atau kamu dapat menyampaikan permintaan/pertanyaan ke WA Customer Service KlikDokter +62-811-800-629.</p><p>Apabila terdapat pengajuan pengembalian dana yang telah disetujui dan diverifikasi, maka pada umumnya waktu proses pengembalian dana tersebut estimasinya selama 2-3 hari kerja.</p>',
	},
	// hubungi-klikdokter
	/*{
		slug: 'customer-care-klikdokter',
		slug_category: 'hubungi-klikdokter',
		title: 'Customer Care KlikDokter',
		answer:
			'<p>Kamu dapat menghubungi Customer Care apabila mengalami kesulitan dalam penggunaan layanan di KlikDokter dengan cara Whatsapp ke nomor 0811-800-629 atau mengirimkan Email ke <a href="mailto:cs@klikdokter.com">cs@klikdokter.com</a>. Jam operasional Customer Care KlikDokter setiap hari selama 24 jam.</p>',
	},*/
	// info-obat
	{
		slug: 'menu-info-obat',
		slug_category: 'info-obat',
		title: 'Menu Info Obat',
		answer:
			'<p>Pada menu <b>Info Obat</b> memungkinkan kamu untuk melakukan pencarian mengenai berbagai jenis obat berdasarkan abjad, kategori, maupun keluhan yang dialami.</p>',
	},
	{
		slug: 'menu-info-obat-az',
		slug_category: 'info-obat',
		title: 'Menu Info Obat A-Z',
		answer:
			'<p>Pada menu <b>Penyakit A-Z</b> memungkinkan kamu dengan mudah melakukan pencarian mengenai berbagai jenis obat berdasarkan abjad.</p>',
	},
	{
		slug: 'menu-berdasarkan-kategori',
		slug_category: 'info-obat',
		title: 'Menu Berdasarkan Kategori',
		answer:
			'<p>Pada menu <b>Berdasarkan Kategori</b> memungkinkan kamu dengan mudah melakukan pencarian mengenai berbagai jenis obat berdasarkan kategori.</p>',
	},
	{
		slug: 'menu-banyak-dicari',
		slug_category: 'info-obat',
		title: 'Menu Banyak Dicari',
		answer:
			'<p>Pada menu <b>Banyak Dicari</b> memunculkan jenis obat yang paling banyak dicari.</p>',
	},
	// info-penyakit
	{
		slug: 'menu-info-penyakit',
		slug_category: 'info-penyakit',
		title: 'Menu Info Penyakit',
		answer:
			'<p>Pada menu <b>Info Penyakit</b> memungkinkan kamu untuk melakukan pencarian mengenai berbagai jenis penyakit berdasarkan abjad dan keluhan yang dialami.</p>',
	},
	{
		slug: 'menu-penyakit-az',
		slug_category: 'info-penyakit',
		title: 'Menu Info Penyakit A-Z',
		answer:
			'<p>Pada menu <b>Penyakit A-Z</b> memungkinkan kamu dengan mudah melakukan pencarian mengenai berbagai jenis penyakit berdasarkan abjad.</p>',
	},
	{
		slug: 'menu-berdasarkan-keluhan',
		slug_category: 'info-penyakit',
		title: 'Menu berdasarkan keluhan',
		answer:
			'<p>Pada menu <b>Berdasarkan Keluhan</b> memungkinkan kamu dengan mudah melakukan pencarian mengenai berbagai jenis penyakit berdasarkan keluhan.</p>',
	},
];

export const FAQCategories = [
	{
		slug: 'profil-saya',
		iconUrl: '/icons/faq/profil-saya.svg',
		title: 'Akun Kamu',
		desc: 'Atur atau perbaharui informasi dan keamanan akun Kamu.',
		questions: FAQQuestions.filter((q) => q.slug_category === 'profil-saya'),
	},
	/*
	{
		slug: 'tebus-resep',
		iconUrl: '/icons/faq/tebus-resep.svg',
		title: 'Tebus Resep',
		desc: 'Tebus berbagai macam obat terlengkap tanpa perlu keluar rumah.',
		questions: FAQQuestions.filter((q) => q.slug_category === 'tebus-resep'),
	},
	{
		slug: 'info-obat',
		iconUrl: '/icons/faq/info-obat.svg',
		title: 'Info Obat',
		desc: 'Segala kebutuhan obat yang perlu Kamu ketahui.',
		questions: FAQQuestions.filter((q) => q.slug_category === 'info-obat'),
	},*/
	{
		slug: 'info-penyakit',
		iconUrl: '/icons/faq/info-penyakit.svg',
		title: 'Info Penyakit',
		desc: 'Segala informasi seputar penyakit yang perlu Kamu ketahui.',
		questions: FAQQuestions.filter((q) => q.slug_category === 'info-penyakit'),
	},
	/*{
		slug: 'metode-pembayaran',
		iconUrl: '/icons/faq/metode-pembayaran.svg',
		title: 'Pembayaran',
		desc: 'Metode pembayaran yang mudah sesuai pilihanmu.',
		questions: FAQQuestions.filter((q) => q.slug_category === 'metode-pembayaran'),
	},*/
	{
		slug: 'health-tools',
		iconUrl: '/icons/faq/health-tools.svg',
		title: 'Health Tools',
		desc: 'Pantau kesehatan Kamu dengan tools interaktif kami.',
		questions: FAQQuestions.filter((q) => q.slug_category === 'health-tools'),
	},
	{
		slug: 'hubungi-klikdokter',
		iconUrl: '/icons/faq/hubungi-klikdokter.svg',
		title: 'Hubungi KlikDokter',
		desc: 'Siap siaga menjawab segala pertanyaan Kamu',
		questions: FAQQuestions.filter((q) => q.slug_category === 'hubungi-klikdokter'),
	},
];
